import Helpers from '../../../../common/helpers/Helpers';
import Constants from '../../../../common/constants/Constants';

export const startDesktopSharing = (serialNumber, guid, sessionId) => {
  let headers = {
    'Content-Type': 'application/json'
  };

  let dataAsString = JSON.stringify({ guid, sessionId });

  return Helpers.post(
    `${Constants.DESKTOP_SHARING_URL}/connect/${serialNumber}`,
    headers,
    dataAsString
  );
};

export const stopDesktopSharing = (serialNumber, guid) => {
  let headers = {
    'Content-Type': 'application/json'
  };

  let dataAsString = JSON.stringify(guid);

  return Helpers.post(
    `${Constants.DESKTOP_SHARING_URL}/close/${serialNumber}`,
    headers,
    dataAsString
  );
};

  export const getDesktopSharingStatus = (serialNumber) => {
    let headers = {
      'Content-Type': 'application/json'
    };
  
    // let dataAsString = JSON.stringify(guid);
  
    return Helpers.get(
      `${Constants.DESKTOP_SHARING_URL}/status/${serialNumber}`,
      headers,
    );
};
